import React from "react";
import { chatLoadErrorText, chatLoadRefreshText } from "../../../NewConstants/ErrorConstants";

const ChatLoadError = ({ selectedLanguage, onRefresh = () => {} }) => {
  const language = chatLoadErrorText[selectedLanguage]
    ? selectedLanguage
    : "en";

  return (
    <div
      className="w-full rounded-xl bg-[var(--neutral-white)] border border-gray-200 shadow-sm px-3 pt-5 pb-3 flex flex-col items-center gap-5"
      role="alert"
    >
      <p className="text-[18px] leading-[1.6] text-center text-[var(--dark-neutral-4)] px-2">
        {chatLoadErrorText[language]}
      </p>
      <button
        type="button"
        className="w-full h-[2.75rem] rounded-lg bg-[var(--primary-dark)] text-white flex items-center justify-center gap-2 active:opacity-90"
        onClick={onRefresh}
      >
        <img
          src="/Assets/Images/ArrowClockwiseWhite.svg"
          alt=""
          className="h-5 w-5"
        />
        <span className="text-[18px]">{chatLoadRefreshText[language]}</span>
      </button>
    </div>
  );
};

export default ChatLoadError;
